<template>
  <div>
    <h4>Edit word ({{this.lexiconWord}})</h4><br />
      <div class="form-group">
        <label for="lexiconWord"><b>Word:</b></label>
        <input v-on:keyup.enter="onGeneratePhoneme()" type="text" v-model="lexiconWord" class="form-control" />
        <div class="invalid-feedback">
          <div>Word value is required.</div>
        </div>
      </div>

      <div>
        <div class="form-group">
            <button @click.stop="onGeneratePhoneme()">Generate <b>guides</b> & <b>phonemes</b></button>
            <img v-if="loadingEasy" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" /><br />
            <p v-if="emptyGuideMsg">
              <font color="red">The submitted word generated an empty set of guides and phonemes, Please provide your accordingly.</font>
            </p>
        </div>
      </div>

      <div class="form-group">
        <table style="border-collapse: separate; border-spacing: 5px">
          <tbody>
            <tr v-for="item in renderProps" :key="item.key">
              <td class="text-center align-middle" :style="{ width: '35%', 'vertical-align': 'middle', 'background-color': item.color ? item.color : '#000000'}" style="color: black;">
                <h3 v-show="!item.showEdit" style="font-family: consolaB">&nbsp;{{item.guide}}&nbsp;</h3>
                <input v-show="item.showEdit && item.guide.trim()" v-on:keyup.enter="onChangeGuide(item.key)" type="text" :style="{ 'font-size': '28px', 'font-family': 'consolaB', width: '50%', 'text-align': 'center'}" v-model="item.guide" />
              </td>
              <td class="text-center" :style="{ width: '60%','vertical-align': 'middle', 'color': 'black', 'background-color': item.color ? item.color : '#FFFFFF' }">
                <h3 style="font-family: consolaI">&nbsp;&nbsp;<b>{{item.phoneme}}</b>&nbsp;&nbsp;</h3>
              </td>&nbsp;
              <!-- <td>
                <audio controls [src]="env.apiUrl.replace(':8080', '') + '/media/guides/' + waves[i] + '.wav'" type="audio/webm"></audio>
              </td>&nbsp; -->
              <td v-show="!item.showEdit" class="text-center align-middle">
                <img v-show="item.loadingEditGuideState" class="pl-2"
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                <a style="cursor: pointer;" @click.stop="onEditGuide(item.key)">
                  <i class="bi bi-pen-fill">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg>
                  </i>
                </a>&nbsp;
                <a style="cursor: pointer;" @click.stop="onDeleteGuide(item.key)">
                  <i class="bi bi-calendar-x-fill">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-x-fill" viewBox="0 0 16 16"><path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM6.854 8.146 8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 1 1 .708-.708z"/></svg>
                  </i>
                </a>
              </td>
              <td v-show="item.showEdit" class="text-center align-middle">
                <a style="cursor: pointer;" @click.stop="onChangeGuide(item.key)">&nbsp;
                  <i class="bi bi-save2-fill">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-save2-fill" viewBox="0 0 16 16"><path d="M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v6h-2a.5.5 0 0 0-.354.854l2.5 2.5a.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 10.5 7.5h-2v-6z"/></svg>
                  </i>
                </a>
                <a style="cursor: pointer;" @click.stop="onCancelEditGuide(item.key)">&nbsp;
                  <i class="bi bi-x-circle-fill">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/></svg>
                  </i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="renderProps.length > 0"><br />
          <div v-show="!showProposeGuide">
            <a cursor="pointer">
              <i class="bi bi-file-earmark-plus-fill">&nbsp;Didn't find a proper guide above?</i>
            </a>&nbsp;
            <button @click.stop="onShowProposeGuide()">Propose a guide</button>
          </div>
          <div v-show="showProposeGuide">
            <div class="form-group">
              <table>
                <tr>
                  <td>
                    <label>
                      <b>Proposed guide: &nbsp;</b>
                    </label>
                  </td>
                  <td>
                    <input type="text" class="form-control" v-model="proposedGuide" v-on:keyup.enter="onSaveProposeGuide()" />
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <a style="cursor: pointer;" @click.stop="onSaveProposeGuide()">&nbsp;
                      <i class="bi bi-save2-fill">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-save2-fill" viewBox="0 0 16 16"><path d="M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v6h-2a.5.5 0 0 0-.354.854l2.5 2.5a.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 10.5 7.5h-2v-6z"/></svg>
                      </i>
                    </a>
                    <a cursor="pointer" @click.stop="onCancelProposeGuide()">&nbsp;
                      <i class="bi bi-x-circle-fill">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/></svg>
                      </i>
                    </a>
                    <img v-show="loadingEasyUserGuide" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                  </td>
                </tr>
              </table>
            </div>
        </div>
      </div>
      <div class="float-right">
        <br /><br />
        <button v-show="saveState === 0" class="btn btn-danger" @click="$router.push({name: 'LexiconWords', params: {id: groupId}})">Close & Go to list</button>&nbsp;
        <button v-show="renderProps.length > 0 && saveState === 0" @click="onSaveWord()" class="btn btn-success">Save Word</button>
        <button v-show="saveState === 1" class="btn btn-info">Word was saved successfully, going back to list...</button>
        <button v-show="saveState === 2" class="btn btn-danger">Something went wrong while saving word.</button>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import router from '../router'

export default {
  name: 'LexiconWordEdit',
  data: function () {
    return {
      wordId: this.$route.params.id,
      groupId: 0,
      lexiconWord: this.$route.params.word,
      loadingEasy: false,
      loadingEasyUserGuide: false,
      emptyGuideMsg: '',
      showProposeGuide: false,
      proposedGuide: '',
      saveState: 0,
      renderProps: []
    }
  },
  mounted: function () {
    if (!this.$route.params.id) {
      router.push({ name: 'Lexicons' })
    } else {
      apiClient.get('/api/lexicons/word/view/' + this.$route.params.id).then((response) => {
        this.groupId = response.data.word.group_id
        this.lexiconWord = response.data.word.word
        if (!response.data.word.guides || !response.data.word.guides.length === 0) {
          return this.onGeneratePhoneme()
        }

        const lexiconGuides = response.data.word.guides.split(',')
        const lexiconPhonemes = response.data.word.phonemes.split(',')
        const lexiconColors = response.data.word.colors.split(',')

        for (let i = 0; i < lexiconGuides.length; i++) {
          const obj = {}
          obj.key = i
          obj.guide = lexiconGuides[i]
          obj.showEdit = false
          obj.phoneme = lexiconPhonemes[i]
          obj.color = lexiconColors[i]
          obj.loadingEditGuideState = false

          this.renderProps.push(obj)
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  },
  methods: {
    onGeneratePhoneme: function () {
      if (!this.lexiconWord.trim()) {
        return false
      }

      this.lexiconWord = this.lexiconWord.split(' ').join('_')
      this.loadingEasy = true
      this.renderProps = []
      this.showProposeGuide = false
      this.proposedGuide = ''
      this.emptyGuideMsg = false

      apiClient.get('/api/lexicons/props/' + this.lexiconWord).then((response) => {
        if (response.data.lexicon_guides.length === 0) {
          this.emptyGuideMsg = true
          return
        }
        const lexiconGuides = response.data.lexicon_guides
        const lexiconPhonemes = response.data.lexicon_phonemes
        const lexiconColors = this.$randomColor({ count: lexiconGuides.length, luminosity: 'light', hue: 'random' })

        for (let i = 0; i < lexiconGuides.length; i++) {
          const obj = {}
          obj.key = i
          obj.guide = lexiconGuides[i]
          obj.showEdit = false
          obj.phoneme = lexiconPhonemes[i]
          obj.color = lexiconColors[i]
          obj.loadingEditGuideState = false

          this.renderProps.push(obj)
        }

        this.loadingEasy = false
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    },
    onShowProposeGuide: function () {
      this.showProposeGuide = true
    },
    onCancelProposeGuide: function () {
      this.showProposeGuide = false
    },
    onChangeGuide: function (index) {
      this.renderProps[index].showEdit = false
    },
    onEditGuide: function (index) {
      this.renderProps[index].showEdit = true
    },
    onDeleteGuide: function (index) {
      this.renderProps.splice(index, 1)
    },
    onCancelEditGuide: function (index) {
      this.renderProps[index].showEdit = false
    },
    onSaveWord: function () {
      apiClient.post('/api/lexicons/word/edit', {
        word: this.lexiconWord,
        word_id: this.wordId,
        guides: this.renderProps.map(item => { return item.guide }).join(','),
        phonemes: this.renderProps.map(item => { return item.phoneme }).join(','),
        colors: this.renderProps.map(item => { return item.color }).join(',')
      }).then((response) => {
        this.renderProps = []
        if (response.status === 201) {
          router.push({ name: 'LexiconWords', params: { id: this.groupId } })
        } else {
          this.renderProps = []
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    },
    onSaveProposeGuide: function () {
      this.loadingEasyUserGuide = true
      apiClient.get('/api/lexicons/props/' + this.proposedGuide).then((response) => {
        const lexiconGuide = response.data.lexicon_guides[0]
        const lexiconPhoneme = response.data.lexicon_phonemes[0]

        const obj = {}
        obj.key = this.renderProps.length
        obj.guide = lexiconGuide
        obj.showEdit = false
        obj.phoneme = lexiconPhoneme
        obj.color = this.$randomColor({ count: 1, luminosity: 'light', hue: 'random' })
        obj.loadingEditGuideState = false

        this.renderProps.push(obj)
        this.loadingEasyUserGuide = false
        this.showProposeGuide = false
        this.proposedGuide = ''
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  }
}
</script>
